import { render, staticRenderFns } from "./AddExternalGrant.vue?vue&type=template&id=c209a6d6&scoped=true&"
import script from "./AddExternalGrant.vue?vue&type=script&lang=ts&"
export * from "./AddExternalGrant.vue?vue&type=script&lang=ts&"
import style0 from "./AddExternalGrant.vue?vue&type=style&index=0&id=c209a6d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c209a6d6",
  null
  
)

export default component.exports